// extracted by mini-css-extract-plugin
module.exports = {"header":"EditorDemo_header__3aerf","p":"EditorDemo_p__31WfH","editor":"EditorDemo_editor__3olbR","copyBoxDiv":"EditorDemo_copyBoxDiv__3Zfao"};